import styled from '@emotion/native';
import React from 'react';
import { StyleProp, ViewStyle, TextStyle } from 'react-native';
import { HelperText } from 'react-native-paper';

interface ErrorFrameProps {
  children: React.ReactNode;
  errorVisible: boolean;
  errorText: string;
  containerStyle?: StyleProp<ViewStyle>;
  errorTextStyle?: StyleProp<TextStyle>;
}

const ErrorFrame: React.FC<ErrorFrameProps> = ({
  children,
  errorVisible = false,
  errorText,
  containerStyle = {},
  errorTextStyle = {},
}: ErrorFrameProps) => {
  return (
    <OuterContainer style={containerStyle}>
      {children}
      <ErrorText type="error" visible={errorVisible} style={errorTextStyle}>
        {errorText}
      </ErrorText>
    </OuterContainer>
  );
};

const OuterContainer = styled.View({});

const ErrorText = styled(HelperText)({
  fontSize: 12,
  paddingVertical: 0,
});

export default ErrorFrame;
